/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerActiveDeviceNetworkLockPolicyDto } from '../models/EntityModelResponseContainerActiveDeviceNetworkLockPolicyDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CareAdminDeviceActiveNetworkPolicyControllerService {
    /**
     * @returns EntityModelResponseContainerActiveDeviceNetworkLockPolicyDto OK
     * @throws ApiError
     */
    public static read({
        deviceId,
    }: {
        deviceId: number,
    }): CancelablePromise<EntityModelResponseContainerActiveDeviceNetworkLockPolicyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/care/devices/{deviceId}/active-network-lock-status',
            path: {
                'deviceId': deviceId,
            },
        });
    }
}
